import { Component, Vue } from 'vue-property-decorator'
import BasketPage from '~/components/page/basket/BasketPage'
import s from '~/utils/s'
import { BANNER_GROUP_CODE } from '~/types/enum/BannerGroups'

@Component({
  async fetch ({ store, route }) {
    s(store).basket.unselectAll()
    await s(store).basket.fillData()
    await s(store).basket.loadRecommendations(route)
    await s(store).partnerCardBlock.loadPartnerCardBlock(BANNER_GROUP_CODE.cartBanner)
  }
})
export default class extends Vue {
  render () {
    return (
      <BasketPage />
    )
  }
}
